import React, { memo } from 'react';

const ThemeSwitcher = ({
  isOn,
  handleToggle,
  onColor,
}: {
  isOn: boolean;
  handleToggle: () => void;
  onColor: string;
}) => {
  return (
    <label className={`theme-switcher`} htmlFor={`react-switch-new`}>
      <input
        checked={isOn}
        onChange={handleToggle}
        className="theme-switcher__checkbox visually-hidden"
        id={`react-switch-new`}
        type="checkbox"
      />
      <div
        className="theme-switcher__label"
        style={{
          borderColor: isOn ? `#12C20F` : `#000000`,
        }}
      >
        <span
          className={`theme-switcher__btn`}
          style={{
            background: isOn ? `#12C20F` : `#000000`,
          }}
        />
      </div>
      {isOn ? <DarkSVG /> : <LightSVG />}
    </label>
  );
};

const LightSVG = memo(() => {
  return (
    <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M10 4V0H12V4H10ZM16.65 6.75L15.275 5.375L18.075 2.5L19.475 3.925L16.65 6.75ZM18 12V10H22V12H18ZM10 22V18H12V22H10ZM5.35 6.7L2.5 3.925L3.925 2.525L6.75 5.35L5.35 6.7ZM18.05 19.5L15.275 16.625L16.625 15.275L19.475 18.025L18.05 19.5ZM0 12V10H4V12H0ZM3.925 19.5L2.525 18.075L5.325 15.275L6.05 15.95L6.775 16.65L3.925 19.5ZM11 17C9.33333 17 7.91667 16.4167 6.75 15.25C5.58333 14.0833 5 12.6667 5 11C5 9.33333 5.58333 7.91667 6.75 6.75C7.91667 5.58333 9.33333 5 11 5C12.6667 5 14.0833 5.58333 15.25 6.75C16.4167 7.91667 17 9.33333 17 11C17 12.6667 16.4167 14.0833 15.25 15.25C14.0833 16.4167 12.6667 17 11 17ZM11 15C12.1 15 13.0417 14.6083 13.825 13.825C14.6083 13.0417 15 12.1 15 11C15 9.9 14.6083 8.95833 13.825 8.175C13.0417 7.39167 12.1 7 11 7C9.9 7 8.95833 7.39167 8.175 8.175C7.39167 8.95833 7 9.9 7 11C7 12.1 7.39167 13.0417 8.175 13.825C8.95833 14.6083 9.9 15 11 15Z"
        fill="#000000"
      />
    </svg>
  );
});

const DarkSVG = memo(() => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M10.1 20C8.7 20 7.38733 19.7333 6.162 19.2C4.93733 18.6667 3.871 17.946 2.963 17.038C2.05433 16.1293 1.33333 15.0623 0.8 13.837C0.266667 12.6123 0 11.3 0 9.9C0 7.46667 0.775 5.32067 2.325 3.462C3.875 1.604 5.85 0.45 8.25 0C7.95 1.65 8.04167 3.26233 8.525 4.837C9.00833 6.41233 9.84167 7.79167 11.025 8.975C12.2083 10.1583 13.5877 10.9917 15.163 11.475C16.7377 11.9583 18.35 12.05 20 11.75C19.5667 14.15 18.4167 16.125 16.55 17.675C14.6833 19.225 12.5333 20 10.1 20ZM10.1 18C11.5667 18 12.925 17.6333 14.175 16.9C15.425 16.1667 16.4083 15.1583 17.125 13.875C15.6917 13.7417 14.3333 13.3793 13.05 12.788C11.7667 12.196 10.6167 11.3917 9.6 10.375C8.58333 9.35833 7.775 8.20833 7.175 6.925C6.575 5.64167 6.21667 4.28333 6.1 2.85C4.81667 3.56667 3.81267 4.554 3.088 5.812C2.36267 7.07067 2 8.43333 2 9.9C2 12.15 2.78767 14.0623 4.363 15.637C5.93767 17.2123 7.85 18 10.1 18Z"
        fill="#D9D9D9"
      />
    </svg>
  );
});

export default ThemeSwitcher;
